import React from 'react';
import {Slide} from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import {books} from '../../content/books/books';
import {bookCoverMap} from '../../content/books/book-covers';
import './BooksCarousel.css';

export default function BooksCarousel() {
  // Only show books that have a cover
  const items = books.filter((b) => bookCoverMap[b.coverKey]);

  const responsiveSettings = [
    {breakpoint: 800, settings: {slidesToShow: 3, slidesToScroll: 3}},
    {breakpoint: 500, settings: {slidesToShow: 2, slidesToScroll: 2}},
    {breakpoint: 100, settings: {slidesToShow: 1, slidesToScroll: 1}},
  ];

  return (
    <div className='slideshow'>
      <hr className='m-4 m-lg-5' />
      <div className='mt-3 adlastbook'>
        You can buy all my Penguin novels from booksellers or online.
      </div>

      <div className='m-3 p-md-5 p-3'>
        <Slide
          slidesToScroll={2}
          slidesToShow={2}
          indicators={true}
          responsive={responsiveSettings}
          duration={3000}
          transitionDuration={700}>
          {items.map((b) => {
            const cover = bookCoverMap[b.coverKey];
            // Pick a “primary buy link” for the carousel:
            const primaryLink =
              b.links?.find((l) => l.label.toLowerCase().includes('amazon'))
                ?.url ||
              b.links?.[0]?.url ||
              '/books';

            return (
              <div
                className='each-slide-effect'
                key={b.id}>
                <a
                  href={primaryLink}
                  target='_blank'
                  rel='noreferrer'>
                  <img
                    src={cover}
                    alt={`${b.title} cover`}
                    className='book'
                  />
                </a>
              </div>
            );
          })}
        </Slide>
      </div>

      <a
        href='https://www.amazon.co.uk/stores/Jane-Corry/author/B01BTZ839E?ref=ap_rdr&store_ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true'
        target='_blank'
        rel='noreferrer'
        className='px-2 py-1 btnLightDark'>
        Click here to find all my books
      </a>

      <hr className='m-4 m-lg-5' />
    </div>
  );
}
